<div class="row m-0 h-100-t" *ngIf="service.selectedProduct$ | async as product">
  <div class="p-0" [class.col-9]="!service.solo" [class.col-12]="service.solo">
    <mat-tab-group [animationDuration]="'0ms'" class="mat-tab-group-colgrow mat-tab-group-headerstyle flex-grow-1 product-tab-group h-100" [(selectedIndex)]="selectedTab" (selectedIndexChange)="selectedTabChange.emit($event)">
      <mat-tab *ngIf="!service.solo">
        <ng-template mat-tab-label>
          <mat-icon class="mr-2">receipt_long</mat-icon>
          Part Info
        </ng-template>
        <div>
          <product-detail-form *ngFor="let i of [product.productId]"></product-detail-form>
        </div>
      </mat-tab>
      <mat-tab *ngIf="!service.solo">
        <ng-template mat-tab-label>
          <mat-icon svgIcon="file-document-multiple" class="mr-2"></mat-icon>
          Documents
        </ng-template>
        <order-detail-documents [documents]="convertDocuments(product.documents)"
          (documentsAdded)="onDocumentsAdded($event)"
          (documentDeleted)="onDocumentDeleted($event)"
          (tagsEdited)="onDocumentTagsUpdated($event)"
          [editing]="editing" [uploadFunction]="this.service.batchUploadDocuments.bind(service)"></order-detail-documents>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon svgIcon="cube" class="mr-2"></mat-icon>
          Material
        </ng-template>
        <div>
          <product-material></product-material>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon svgIcon="format-list-numbered" class="mr-2"></mat-icon>
          Workflow
        </ng-template>
        <div class="h-100-t">
          <product-workflow></product-workflow>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon svgIcon="package-variant" class="mr-2"></mat-icon>
          Purchased Items
        </ng-template>
        <ng-template matTabContent>
          <div class="h-100-t">
            <product-purchased-items></product-purchased-items>
          </div>
        </ng-template>
      </mat-tab>
      <ng-container *ngLet="service.postChangesOrder$ | async as record">
      <mat-tab *ngIf="record.discriminator === 'Estimate' && product?.previousPlanningChanges && product?.previousPlanningChanges?.length !== 0">
        <ng-template mat-tab-label>
          Planning Changes
          <div class="d-inline-block ml-1 rounded p-1 bg-white text-dark small font-weight-bold text-center" *ngIf="getUnresolvedPlanningChangeCount(product) as count">
            {{ count }}
          </div>
        </ng-template>
        <ng-template matTabContent>
          <div class="h-100-t">
            <estimating-planning-changes-review [product]="product" [editing]="editing" (changed)="service.notifyEdited(product)"></estimating-planning-changes-review>
          </div>
        </ng-template>
      </mat-tab>
      </ng-container>
      <ng-container *ngLet="service.postChangesOrder$ | async as record">
        <mat-tab *ngIf="record.discriminator === 'Estimate' && (record.status === 201 || record.status === 1)">
          <ng-template mat-tab-label>
            Estimate Quality Review
          </ng-template>
          <ng-template matTabContent>
            <div class="h-100-t">
              <product-estimating-review [product]="product"></product-estimating-review>
            </div>
          </ng-template>
        </mat-tab>
      </ng-container>
    </mat-tab-group>
  </div>
  <div *ngIf="!service.solo" class="col-3 p-0 h-100 d-flex flex-column" style="position: relative; z-index: 6; overflow: hidden">
    <div style="height: 48px; z-index: 10" class="bg-dark position-relative">
      &nbsp;
    </div>
    <div class="mat-elevation-z6 position-relative hierarchy-container flex-spread ml-3" style="z-index: 9">
      <product-hierarchy-new>
        <ng-template #postName let-item let-expanded="expanded">
          <span class="badge ml-1 bg-dark text-white" *ngIf="getProductQuantityData(item.productId) | async as qtyData">{{ qtyData.totalQty }}<span *ngIf="qtyData.quantitiesMap.length > 1">+</span></span>
          <ng-container *ngLet="{ record: this.service.postChangesOrder$ | async, product: this.service.getProductObservable(item.productId) | async, allProducts: this.service.allProducts$ | async } as data">
            <div class="bg-white rounded tree-progress-indicators d-flex align-items-center ml-2" *ngIf="service.shouldShowIndicators(data.record) && data.record.status !== 1">
              <div class="microtask-indicator-tree" [ngClass]="getMicroTaskStatusClass(getSimpleTaskStatus(data.product, 'material'))">&nbsp;</div>
              <div class="microtask-indicator-tree" [ngClass]="getMicroTaskStatusClass(getSimpleTaskStatus(data.product, 'workflow'))">&nbsp;</div>
              <div class="microtask-indicator-tree" [ngClass]="getMicroTaskStatusClass(getSimpleTaskStatus(data.product, 'hardware'))">&nbsp;</div>
              <div class="microtask-indicator-tree" *ngIf="item.hasChildren && !expanded" [ngClass]="getMicroTaskStatusClass(getSubassembliesStatus(item.productId, data.allProducts))">&nbsp;</div>
            </div>
            <ng-container
              *ngIf="data.record.discriminator === 'Estimate' && (data.record.status === 1 || data.record.status === 201)"
            >
              <div class="small bg-white font-weight-bold rounded p-2 ml-auto mr-2"
                *ngLet="countAnsweredEstimateReviewQuestions(data.record, item.productId) as estimateReviewAnswered"
              >
                <span class="text-muted">QR: </span>
                <span
                [class.text-danger]="estimateReviewAnswered === 0"
                [class.text-warning]="estimateReviewAnswered > 0 && estimateReviewAnswered < estimateReviewTotal"
                [class.text-success]="estimateReviewAnswered === estimateReviewTotal"
                >
                {{ estimateReviewAnswered }}/{{ estimateReviewTotal }}
                </span>
              </div>
            </ng-container>
          </ng-container>
        </ng-template>
      </product-hierarchy-new>
    </div>
  </div>
</div>